import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

/**
 * Routes for the new Ask Redo full-page chat.
 *
 * Wrap with the merchant `<Page>` so the route gets the full app
 * chrome (top nav + side nav + breadcrumbs) — without this, the
 * route mounts bare and takes over the whole viewport, which isn't
 * the intended design. `hidePadding: () => true` lets the inner
 * `AskRedoPage` own its own layout/padding.
 *
 * The route itself has no permission gate — any authenticated merchant
 * user can land on it.
 *
 * URL shape:
 *   /ask-redo             → new conversation
 *   /ask-redo/:threadId   → continue an existing thread
 *   /ask-redo?q=<text>    → prefill + auto-submit (homepage deep-link)
 */
export const askRedoRoutes: PermissionedRouteObject[] = [
  {
    path: "ask-redo",
    handle: { breadcrumb: "Ask Redo" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AskRedoPage } = await import("../page/ask-redo-page");
          return { Component: AskRedoPage };
        },
      },
      {
        path: ":threadId",
        async lazy() {
          const { AskRedoPage } = await import("../page/ask-redo-page");
          return { Component: AskRedoPage };
        },
      },
    ],
  },
];
